// extracted by mini-css-extract-plugin
export default {"markdownBody":"markdown_markdownBody__OXe4z","headingText":"markdown_headingText__PMqDV"};